import { FullComposeViewState } from 'owa-calendar-compose-types';
import { getComposeStore } from 'owa-calendar-compose-store-manager';
import { FULL_COMPOSE_FORM_TYPE } from 'owa-calendar-helpers-types/lib/ComposeTypes';
import { PluginViewStateAdapter } from 'owa-editor';

export type CalendarPluginViewStateAdapter = () => FullComposeViewState;

export function createPluginViewStateAdapter(
    originalViewState: FullComposeViewState
): CalendarPluginViewStateAdapter;

export function createPluginViewStateAdapter<PluginName extends keyof FullComposeViewState>(
    originalViewState: FullComposeViewState,
    name: PluginName
): PluginViewStateAdapter<FullComposeViewState[PluginName]>;

export function createPluginViewStateAdapter<PluginName extends keyof FullComposeViewState>(
    originalViewState: FullComposeViewState,
    name?: PluginName
): () => FullComposeViewState[PluginName] | FullComposeViewState {
    return () => {
        // Get the current full compose view state from the store, or else the
        // initial view state if it has yet to be placed in the store
        // Then retrieve the current plugin view state from the full compose view state
        const composeStore = getComposeStore();

        // Make sure we are dealing with full compose, not quick compose,
        // which doesn't have plugins (VSO 54074)
        const currentViewState =
            (composeStore.openedForm === FULL_COMPOSE_FORM_TYPE &&
                (composeStore.uiState as FullComposeViewState)) ||
            originalViewState;
        return name ? currentViewState[name] : currentViewState;
    };
}
